import { PortalProfile } from "@/features/portal/components/portal-profile";

/** `/portal/profile` — the client's own read-only profile. */
export default function PortalProfilePage() {
  return <PortalProfile />;
}
